import { isEmpty } from 'remeda';

import { useAppSelector } from '@/shared/lib/redux';

/**
 * Хук авторизации
 */
export const useAuth = () => {
  const { auth } = useAppSelector(state => state.user);

  return {
    isLoggedIn: !isEmpty(auth),
    auth
  };
};
